var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"large":"","type":_vm.type,"max-width":"100%","width":"340","to":_vm.to,"loading":_vm.loading,"disabled":_vm.disabled,"block":""},on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }